import $ from 'jquery';

export default function flashMessage(
  title: string,
  message: string,
  from: string,
  align: string,
  icon: string,
  type: string,
  animIn: string,
  animOut: string,
) {
  $.notify(
    {
      icon: icon,
      title: title,
      message: message,
    },
    {
      type: type,
      placement: {
        from: from,
        align: align,
      },
      animate: {
        enter: animIn,
        exit: animOut,
      },
    },
  );
}

export type FlashMessageType = 'info' | 'success' | 'warning' | 'danger';

export function simpleFlashMessage(
  message: string,
  type: FlashMessageType = 'info',
) {
  flashMessage(
    '',
    message,
    'top',
    'center',
    'fa fa-info-circle',
    type,
    'animated fadeInDown',
    'animated fadeOutUp',
  );
}
